import { webhookEndpointFragment } from './fragments';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const webhookRegenerateSecretAtom = createMutationAtomFactory(
  'automations.webhookRegenerateSecret',
  (params: { automationId: string }) => ({
    automationsWebhookRegenerateSecret: {
      __args: {
        automationId: params.automationId,
      },
      ...webhookEndpointFragment,
    },
  }),
);
